define([
	"csi/action",
	"./Abandon",
	"./Aggregate",
	"./AggregateFrom",
	"./Approve",
	"./ApproveConfirm",
	"./CancelApprovalWorkflow",
	"./CancelController",
	"./CancelOffline",
	"./CloseRevision",
	"./Controller",
	"./Copy",
	"./Delete",
	"./Download",
	"./Edit",
	"./EditAll",
	"./Endorse",
	"./EndPhase",
	"./ForceApprove",
	"./Freeze",
	"./Insert",
	"./Link",
	"./MakeCurrent",
	"./MakePending",
	"./MakePending2",
	"./Manage",
	"./MassUpdateDataSheets",
	"./Move",
	"./MoveDown",
	"./MoveFrom",
	"./MoveUp",
	"./New",
	"./NewFrom",
	"./Popup",
	"./ProxyController",
	"./PurgeAllPreviousRevisions",
	"./PurgeResetRevisions",
	"./PurgeRevisions",
	"./ReopenPhase",
	"./RevertToApproved",
	"./RevertToDraft",
	"./ReviewApprove",
	"./ReviewCancel",
	"./ReviewFail",
	"./ReviewReopen",
	"./ReviewStart",
	"./Revise",
	"./ReviseAndAbandon",
	"./StartApprovalWorkflow",
	"./Submit",
	"./Switchboard",
	"./Unfreeze"
], function (csiAction) {

	// register default controllers
	csiAction.registerControllers("", {
		Aggregate: "csi.action.AggregateController",
		Cancel: "csi.action.CancelController",
		CancelAll: "csi.action.CancelAllController",
		Delete: "csi.action.DeleteController",
		Download: "csi.action.DownloadController",
		Edit: "csi.action.EditController",
		EditAll: "csi.action.Controller",
		Freeze: "csi.action.FreezeController",
		Insert: "csi.action.NewController",
		Link: "csi.action.LinkController",
		Manage: "csi.action.ManageController",
		MakeCurrent: "csi.action.MakeCurrentController",
		Move: "csi.action.MoveController",
		MoveDown: "csi.action.MoveUpDownController",
		MoveUp: "csi.action.MoveUpDownController",
		MoveFrom: "csi.action.MoveFromController",
		New: "csi.action.NewController",
		NewFrom: "csi.action.NewFromController",
		Popup: "csi.action.PopupController",
		Proxy: "csi.action.ProxyController",
		ResetToDefaults: "csi.action.ResetToDefaultsController",
		Submit: "csi.action.SubmitController",
		Unfreeze: "csi.action.UnfreezeController"
	});
});